import { render, staticRenderFns } from "./sampleSubmit.vue?vue&type=template&id=45638c92&scoped=true&"
import script from "./sampleSubmit.vue?vue&type=script&lang=js&"
export * from "./sampleSubmit.vue?vue&type=script&lang=js&"
import style0 from "./sampleSubmit.vue?vue&type=style&index=0&id=45638c92&lang=scss&scoped=true&"
import style1 from "./sampleSubmit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45638c92",
  null
  
)

export default component.exports